/**
 * Adds the schema.org Organization to the site.
 */
import React, { useContext } from 'react';
import { JsonLd } from 'react-schemaorg';
import { Organization } from 'schema-dts';
import { PathContext } from '~/jobiqo/context/app';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';
import { getFrontendAssets } from '~/jobiqo/utils/getFrontend';

interface SiteOrganizationSchemaProps {}
export default function SiteOrganizationSchema({}: SiteOrganizationSchemaProps) {
  const { host } = useContext(PathContext);
  const frontendConfig = useFrontendConfig();
  const { APP } = frontendConfig;
  const logoPath = getFrontendAssets(frontendConfig).logo;
  const SITENAME = APP.SITENAME;
  const SITE_DESCRIPTION = APP.SITE_DESCRIPTION;
  const SCHEMA_ORGANIZATION = APP.SCHEMA.ORGANIZATION;

  return (
    <JsonLd<Organization>
      item={{
        '@context': 'https://schema.org',
        '@type': 'Organization',
        url: SCHEMA_ORGANIZATION?.url || `${host}`,
        logo: SCHEMA_ORGANIZATION?.logo || `${host}${logoPath}`,
        name: SCHEMA_ORGANIZATION?.name || SITENAME,
        description: SCHEMA_ORGANIZATION?.description || SITE_DESCRIPTION,
        ...(SCHEMA_ORGANIZATION ? SCHEMA_ORGANIZATION : {}),
      }}
    />
  );
}
